export default __webpack_public_path__ + "static/media/open-web-icon.b39379fe.svg";